import { useTheme, Stack, Paper, Button, Chip, Box, FormControlLabel, Switch, Link, CircularProgress } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import DataItem from "@components/atoms/DataItem/DataItem";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import ConfirmDialog from "@components/molecules/ConfirmDialog/ConfirmDialog";
import LoadingGif from "../../../assets/gifs/loading.gif";
import { Link as ReactRouterLink } from "react-router-dom";
import { getCurrency } from "@utils/utils";
import { IProductDetailUI } from "src/types/organisms";
import { IProduct } from "src/types/global";
const ProductDetailUI = ({
  id,
  name,
  reference,
  status,
  controllStatus,
  price,
  isLoading,
  showError,
  closeError,
  isDeleting,
  showDialog,
  handleConfirmDialog,
  handleOpenDialog,
  handleCloseDialog,
  handleChangeStatus
}: IProductDetailUI) => {
  const theme = useTheme();
  const classes = {
    buttonDelete: {
      marginTop: 2,
      backgroundColor: isDeleting ? theme.palette.error.main : null,
      color: isDeleting ? "white" : null
    }
  };
  return <>
      <TitlePage title={`Detalles del producto ${name}`} subtitle="En este módulo, puedes explorar la información detallada del producto y tomar decisiones de gestión, ya sea editando o eliminando." />
      <Stack direction={"row"} marginTop={3} spacing={3} alignItems={"flex-start"}>
        <Paper elevation={12} sx={{
        width: 1,
        padding: "24px"
      }}>
          <TitlePaper title="Información del producto" subtitle="Detalle completo de este producto." />
          <Stack direction={"row"} marginTop={3} flexWrap={"wrap"} width={1}>
            {!isLoading && <>
                <DataItem label="Nombre" value={name} />
                <DataItem label="Referencia" value={reference} />
                <DataItem label="Estado" value={status === 0 ? <Chip color="success" sx={{
              fontWeight: 600
            }} label="Activo" /> : <Chip color="secondary" sx={{
              fontWeight: 600
            }} label="Inactivo" />} />
                <DataItem label="Precio" value={getCurrency(price)} />
              </>}
          </Stack>
          <Stack direction={"row"} justifyContent={"center"}>
            <Box component={"img"} display={isLoading ? "block" : "none"} src={LoadingGif} width={170} />
          </Stack>
        </Paper>
        <Paper elevation={12} sx={{
        width: 400,
        padding: "24px",
        height: "fit-content"
      }}>
          <TitlePaper title="Acciones" subtitle="Ten en cuenta que algunas acciones pueden ser irreversibles. Revisar cuidadosamente cada acción antes de confirmarla." />
          {!isDeleting && <>
              <FormControlLabel sx={{
            marginTop: 2
          }} control={<Switch checked={controllStatus} disabled={isLoading} onChange={e => handleChangeStatus(e.target.checked)} />} label="Estado" />
              <Link component={ReactRouterLink} to={`/productos/editar/${id}`} state={({
            id,
            reference,
            description: name,
            price,
            status
          } as IProduct)}>
                <Button onClick={() => null} fullWidth sx={{
              marginTop: 1
            }} disabled={isLoading}>
                  Editar
                </Button>
              </Link>
            </>}
          <Button onClick={isDeleting ? () => null : handleOpenDialog} fullWidth sx={classes.buttonDelete} color="error" disabled={isLoading} endIcon={isDeleting && <CircularProgress thickness={3} size={20} sx={{
          color: "white"
        }} />}>
            {isDeleting ? "Eliminando" : "Eliminar"}
          </Button>
        </Paper>
      </Stack>
      <ErrorAlert open={showError} onClose={closeError} message={"Lo sentimos, no se pudo eliminar este producto"} />
      <ConfirmDialog open={showDialog} cancelAction={handleCloseDialog} confirmAction={handleConfirmDialog} title="Eliminar producto" subtitle="¿Estás seguro de que deseas eliminar este producto?" message="Recuerda, si eliminas el producto no podrás recuperar la información relacionada con este producto una vez que se haya eliminado." cancelLabel="No eliminar" confirmLabel="Sí, eliminar" />
    </>;
};
export default ProductDetailUI;